<script lang="ts" setup>
import { AuthForgotPasswordForm } from '../../auth/components/index';
definePageMeta({
  layout: 'auth',
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
});

useHead({
  title: 'Reset Password',
});
</script>

<template>
  <v-container class="ma-auto d-flex justify-center w-full">
    <AuthForgotPasswordForm />
  </v-container>
</template>

<style lang="scss" scoped>
.v-card {
  margin-top: 132px;
}
</style>
